
export function renderNetraaLHReleaseNotes () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div id="release-details" className="mb-10">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH Release Notes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            Latest updates including feature enhancements, performance improvements, and bug fixes.
          </p>
        </div>

        {/* Confidentiality Statement */}
        {/* <section id="confidentiality" className="mb-12">
          <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 rounded-r-lg">
            <h4 className="text-sm font-bold text-red-800 dark:text-red-300 mb-2">
              Confidentiality Statement
            </h4>
            <p className="text-xs text-red-700 dark:text-red-400 leading-relaxed">
              The information contained in any Communication or Documentation distributed by ApMoSys, including attachments, is strictly confidential and intended solely for delivery to, and authorized use by, the identified addressee(s), as it may contain legally privileged and/or confidential information. If you are not the intended recipient of the Communication, you are hereby notified that any reading, disclosure, dissemination, distribution or copying of the Communication, and any attachments thereto, is strictly prohibited. If you have received the Communication in error, please notify the sender immediately and delete the message, and any copies and printouts thereof, from your records.
            </p>
          </div>
        </section> */}

        {/* Document Authors */}
        <section id="" className="mb-12">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">23rd April 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Introduction */}
        <section id="introduction" className="mb-12">
          <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 dark:to-transparent border border-border-color dark:border-border-dark">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
              Introduction
            </h2>
            <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
              This release is focused on improving the usability, consistency, and reliability of Netraa LH across key operational modules. While the previous release strengthened governance and escalation workflows, this update addresses day-to-day user experience gaps, UI inconsistencies, and functional inefficiencies identified during active usage.
            </p>
            <ul className="list-disc pl-5 mt-3 text-sm text-text-muted dark:text-gray-400">
              <li>Improved Data Visibility & Navigation</li>
              <li>UI/UX Consistency and Responsiveness</li>
              <li>Accurate State Management</li>
              <li>Enhanced Filtering, Sorting, and Data Handling</li>
            </ul>
          </div>
        </section>

        {/* Key Enhancements */}
        <section id="enhancements" className="mb-16">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
            Key Enhancements
          </h2>

          <div className="space-y-6">

            {[
              {
                title: "Client-Level Data Aggregation (Client Clubbing)",
                items: [
                  "Users can now view distinct client names along with their corresponding error counts within Live Dashboard filters (including terminated views)",
                  "Clicking on a client name enables users to drill down into all associated terminated monitors",
                  "This enhancement enables faster identification of client-specific issues and patterns, significantly improving operational monitoring efficiency."
                ]
              },
              {
                title: "UI Stability & Interaction Fixes",
                items: [
                  "CRUD menus now properly dismiss when clicking outside or interacting with contextual menus (three-dot actions)",
                  "Instance search dropdowns now behave as expected, closing on outside clicks and avoiding UI overlap issues",
                  "These fixes eliminate friction in routine operations and ensure predictable UI behavior."
                ]
              },
              {
                title: "Controlled Deletion Behavior",
                items: [
                  "Multiple escalation deletions have been restricted to prevent accidental bulk data loss",
                  "This introduces a safeguard ensuring that deletion actions remain intentional and controlled"
                ]
              },
              {
                title: "Improved Page State Management",
                items: [
                  "After deleting exceptions, users are now returned to the same position on the page instead of experiencing a full refresh",
                  "This significantly enhances usability by maintaining context and workflow continuity."
                ]
              },
              {
                title: "Enhanced Filtering & Data Consistency",
                items: [
                  "Filters on the Escalation History page now work in sync with each other, ensuring consistent and accurate results",
                  "Date filter has been removed from the Live Dashboard to streamline the interface and avoid redundant filtering"
                ]
              },
              {
                title: "Escalation History Improvements",
                items: [
                  "Single-click Excel download for escalation history reports",
                  "Ability to increase row count in the escalation history table for better visibility",
                  "Default sorting updated to show latest escalations first",
                  "Column-level sorting and type-to-search functionality added for faster data access"
                ]
              },
              {
                title: "UI Enhancements for Visual Consistency",
                items: [
                  "All module icons in the left-hand navigation menu have been updated, improving clarity and visual alignment",
                  "View Journey UI improvements allow users to easily view screenshots and navigate seamlessly"
                ]
              },
              {
                title: "Navigation & Accessibility Improvements",
                items: [
                  "The Settings module is now accessible directly from the left-hand navigation menu",
                  "A fix ensures that the left-hand module is always visible within the Settings page"
                ]
              },
              {
                title: "Execution Status Logic Correction",
                items: [
                  "If the last execution of a monitor was terminated, it will continue to reflect Terminated status",
                  "This remains until a successful execution occurs, even if the current run is in progress"
                ]
              }
            ].map((item, i) => (
              <div key={i} className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
                <div className="flex gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 font-bold text-sm">
                    {i + 1}
                  </div>
                  <div>
                    <h4 className="font-semibold text-text-main dark:text-white mb-2">
                      {item.title}
                    </h4>
                    <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                      {item.items.map((p, j) => (
                        <li key={j}>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </section>

        {/* Impact */}
        <section id="impact" className="mb-16">
          <div className="p-8 bg-surface-light dark:bg-surface-dark">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
              Impact & Business Value
            </h2>

            <ul className="list-disc pl-5 text-sm text-text-muted dark:text-gray-400 space-y-2">
              <li>User Experience: Smoother interactions and reduced UI friction</li>
              <li>Operational Efficiency: Faster navigation, better filtering, and improved data access</li>
              <li>Data Accuracy: Correct execution states and synchronized filters</li>
              <li>Risk Reduction: Controlled deletion mechanisms prevent accidental data loss</li>
              <li>Visual Clarity: Updated icons and improved UI consistency</li>
            </ul>
          </div>
        </section>

        {/* Notes */}
        <section id="notes" className="mb-10">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">
            Additional Notes
          </h2>
          <ul className="list-disc pl-5 text-sm text-text-muted dark:text-gray-400 space-y-2">
            <li>No functional disruptions expected; changes are non-breaking and backward compatible</li>
            <li>Improvements are based on real user feedback and observed usage patterns</li>
            <li>No additional training required; enhancements are intuitive and incremental</li>
          </ul>
        </section>

      </div>
    </main>
  </div>
);
}